import React from 'react';
//import PropTypes from 'prop-types';
import "./style.css";

export function ShadowIcon(props) {

    const {children} = props;

    return (<div className={"shadow-icon"}>
        {children}
    </div>);

}

ShadowIcon.propTypes = {};

ShadowIcon.defaultProps = {};

export default ShadowIcon;